module.exports = __webpack_public_path__ + "assets/img/ps-5.72a967cf.png";